import { render } from "./MenuMinimized.vue?vue&type=template&id=29883250&scoped=true"
import script from "./MenuMinimized.vue?vue&type=script&lang=js"
export * from "./MenuMinimized.vue?vue&type=script&lang=js"

import "./MenuMinimized.vue?vue&type=style&index=0&id=29883250&lang=scss"
import "./MenuMinimized.vue?vue&type=style&index=1&id=29883250&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29883250"]])

export default __exports__